<script>
    /* global String */
    /* global Boolean */

    import LazyHandler from '../helper/lazyHandler.js';

    let lazyHandler = new LazyHandler({
        threshold: 0
    });

    /**
     * This function is a workaround for an issue in Safari, where the child vnodes
     * of a noscript vnode do not have a tag name and will render the contained elements (such as img)
     * as an escaped html string.
     * @param vnodes {array}
     */
    function combineChildHTML(vnodes) {
        return vnodes.reduce(
            (html, vnode) => html + vnode.text,
            ''
        );
    }

    export default {

        name: 'LazyElement',

        render(createElement) {
            let options = { class: 'lazy-element lazy-element--pending' },
                children;

            if (this.rendered) {
                options.class = 'lazy-element lazy-element--rendered';

                if (this.$slots.default.some(vnode => !!vnode.tag)) {
                    children = this.$slots.default;
                } else {
                    options.domProps = {
                        innerHTML: combineChildHTML(this.$slots.default)
                    };
                }
            }

            return createElement(this.tagName, options, children);
        },

        data() {
            return {
                rendered: false
            }
        },

        props: {
            tagName: {
                type: String,
                default: 'div'
            },
            instant: {
                type: Boolean,
                default: false
            }
        },

        methods: {
            render() {
                this.rendered = true;
            }
        },

        mounted() {
            lazyHandler.addViewModel(this);
        },

        updated() {
            if (this.rendered && window.picturefill) {
                picturefill({ elements: [ ...this.$el.querySelectorAll('img') ] })
            }
        },

        destroyed() {
            lazyHandler.removeViewModel(this);
        }

    }
</script>

<style>
    .lazy-element {
        position: relative;
        background: rgba(0,0,0,0.5);
        opacity: 0;
        transform: translateY(10px) scale(.75);
        transition: opacity .3s cubic-bezier(0.6, 0.04, 0.98, 0.335), transform .3s cubic-bezier(0.23, 1, 0.32, 1);

        -webkit-column-break-inside: avoid;
        page-break-inside: avoid;
        break-inside: avoid-column;
    }
    .lazy-element--rendered {
        background: none;
        opacity: 1;
        transform: translate(0) scale(1);
    }
    .lazy-element img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .lazy-element img[src$='.svg'] {
        object-fit: contain;
    }
</style>